import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-content-region',
  templateUrl: './content-region.component.html'
})
export class ContentRegionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
